import axios from "axios";
import { projectUrls } from "../../../URL/ApplicationUrls";

export const createProject = async () => {
  const response = await axios.post(projectUrls.base.apiUrl);
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  const json = response.data;
  if (!json.Success) {
    throw new Error("Got Network response, but no Success");
  }

  return json.Data.ProjectId as number;
};
